import { observable, action } from 'mobx';
import { SdAnalytics } from 'api';

class SdAnalyticsStore {
  @observable analytics;

  @observable fetchState;

  anketId;

  @action.bound
  async getAnalytics(anketId) {
    if (this.anketId === anketId) {
      return;
    }

    this.fetchState = 'pending';

    try {
      const response = await SdAnalytics.getAnalytics(anketId);
      this.analytics = response.data;
      this.fetchState = 'fulfilled';
      this.anketId = anketId;
    } catch (e) {
      this.fetchState = 'rejected';
    }
  }
}

const sdAnalyticsStore = new SdAnalyticsStore();

export default sdAnalyticsStore;
